import { IDataList } from '../model';

export interface Installation {
  id: string;
  name: string;
  status: string;
  createdAt: string;
  updatedAt: string;
}

export interface InstallationsState {
  list: IDataList<Installation[]>;
  loading: boolean;
  error: string | null;
}

export const INSTALLATIONS_ACTION_TYPES = {
  FETCH_INSTALLATIONS_REQUEST: '@installations/FETCH_INSTALLATIONS_REQUEST',
  FETCH_INSTALLATIONS_SUCCESS: '@installations/FETCH_INSTALLATIONS_SUCCESS',
  FETCH_INSTALLATIONS_FAILURE: '@installations/FETCH_INSTALLATIONS_FAILURE',
} as const;

export interface FetchInstallationsParams {
  limit?: number;
  offset?: number;
}

export const INSTALLATIONS_INITIAL_STATE: InstallationsState = {
  list: {
    data: [],
    total: 0,
    offset: 0,
    limit: 10,
  },
  loading: false,
  error: null,
}; 